var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500488 14.4601V17.5001C0.500488 17.7801 0.720488 18.0001 1.00049 18.0001H4.04049C4.17049 18.0001 4.30049 17.9501 4.39049 17.8501L15.3105 6.94006L11.5605 3.19006L0.650488 14.1001C0.550488 14.2001 0.500488 14.3201 0.500488 14.4601ZM18.2105 4.04006C18.6005 3.65006 18.6005 3.02006 18.2105 2.63006L15.8705 0.290059C15.4805 -0.0999414 14.8505 -0.0999414 14.4605 0.290059L12.6305 2.12006L16.3805 5.87006L18.2105 4.04006Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.2e69fb12145534a40c848b551e4aa164.svg";
export { ForwardRef as ReactComponent };